<script>
    import { onMount } from 'svelte';
    import {
        industryCategoryGroupName,
        months,
        pricesFilterList,
    } from '../helpers/consts';
    import V3Factory from '../helpers/V3';
    import { name, price, types, date, cities } from '../store/search';

    export let search;
    let citiesArray = [];
    let typesArray = [];

    let isLoading = true;
    let citiesFilter = [];
    let previousDate = '';
    let previousPrice = '';

    $: typesArray, types.set(typesArray);
    $: citiesArray, cities.set(citiesArray);

    function uncheckDate(e) {
        date.set(e.target.value);
        if ($date == previousDate) {
            e.target.checked = false;
            previousDate = '';
            date.set(new Date());
        } else {
            previousDate = e.target.value;
        }
    }

    function uncheckPrice(e) {
        price.set(e.target.value);
        console.log($price);
        if ($price == previousPrice) {
            e.target.checked = false;
            price.set('');
            previousPrice = '';
        } else {
            previousPrice = e.target.value;
        }
    }

    onMount(async () => {
        isLoading = true;
        const { getCountry, getChildLocations } = V3Factory();
        const country = await getCountry(); //Country

        const states = await getChildLocations(country[0].Id); //State
        const naraState = states.filter((state) => state.Code === 'SNrK'); //SNrK (Nara Ken)

        const _cities = await getChildLocations(naraState[0].Id);
        citiesFilter = _cities;
        isLoading = false;
    });
</script>

{#key cities}
    <div class="putOn-mv">
        <div class="l-inner">
            <form class="searchForm">
                <div class="selectBox__wrap">
                    <div class="selectBox">
                        <div class="selectBox__head">
                            <p class="selectBox__ttl">MONTHS</p>
                            <p class="selectBox__desc" />
                            <span class="selectBox__plus" />
                        </div>
                        <div class="filterItem__wrap">
                            <div class="filterItem selectMon">
                                {#each months as month}
                                    <label>
                                        <input
                                            type="radio"
                                            name="mon[]"
                                            on:click={uncheckDate}
                                            value="{new Date().getFullYear()}/{month.no}/01"
                                        /><span
                                            ><span>{month.no}</span
                                            >{month.month}</span
                                        >
                                    </label>
                                {/each}
                            </div>
                        </div>
                        <div class="selectBox__head head2 ">
                            <p class="selectBox__ttl">PRICES</p>
                            <p class="selectBox__desc" />
                            <span class="selectBox__plus" />
                        </div>
                        <div class="filterItem__wrap ">
                            <div class="filterItem selectMon seasons">
                                {#each pricesFilterList as priceFilter}
                                    <label>
                                        <input
                                            type="radio"
                                            name="sum[]"
                                            on:click={uncheckPrice}
                                            value={priceFilter.value}
                                        /><span>{priceFilter.label}</span>
                                    </label>
                                {/each}
                            </div>
                        </div>
                        <div class="selectBox__head head2 ">
                            <p class="selectBox__ttl">KEYWORD</p>
                            <p class="selectBox__desc" />
                            <span class="selectBox__plus" />
                        </div>
                        <div class="filterItem__wrap ">
                            <div class="filterItem selectMon seasons">
                                <label style="width:100%">
                                    <input
                                        type="text"
                                        style="display:block; width: 100%; padding: 8px; border: 0; background: transparent"
                                        placeholder="Keyword"
                                        bind:value={$name}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="selectBox">
                        <div class="selectBox__head">
                            <p class="selectBox__ttl">CATEGORIES</p>
                            <p class="selectBox__desc" />
                            <span class="selectBox__plus" />
                        </div>
                        <div class="filterItem__wrap">
                            <div class="filterItem selectCat">
                                {#each industryCategoryGroupName as industry}
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="cat[]"
                                            bind:group={typesArray}
                                            value={industry.id}
                                        /><span>{industry.name}</span>
                                    </label>
                                {/each}
                            </div>
                        </div>
                        <div class="selectBox__head head2">
                            <p class="selectBox__ttl">CITIES</p>
                            <p class="selectBox__desc" />
                            <span class="selectBox__plus" />
                        </div>
                        <div class="filterItem__wrap">
                            <div class="filterItem selectCat">
                                {#each citiesFilter as city}
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="tag[]"
                                            bind:group={citiesArray}
                                            value={city.Id}
                                        /><span>{city.Name}</span>
                                    </label>
                                {/each}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-btn orange" on:click={search}>
                    <input type="submit" value="FILTER" /><span class="arrow" />
                </div>
            </form>
        </div>
    </div>
{/key}
